$(document).ready(function(){ 
    $('#corporate_slider').flickity({
  cellSelector: '.newarrival_slide',
  wrapAround : false,
  autoPlay: false,
  fade: false,
  // freeScroll: true,
  contain: true,
  pageDots: false,
  cellAlign: 'left',
  groupCells: true,
  imagesLoaded: true,
  selectedAttraction: 0.05,
  freeScroll: true,
  freeScrollFriction: 0.03
});
$(function() {
         $(".toggle-section").on("click", function (a) {
        const minusIcon = $(this).children('.minus_icon');
        const plusIcon = $(this).children('.plus_icon');
        var sectionContent = $(this).parent('.section-header').next('.section-content');
        console.log(sectionContent)
        if (sectionContent.css('display') == 'none') {
        // Show plus icon and hide minus icon
          minusIcon.css("display","inline-block");
          plusIcon.css("display","none");
        } else {
        // Show minus icon and hide plus icon
          minusIcon.css("display","none");
          plusIcon.css("display","inline-block");
        }
        $(`#${$(this).data("toggle-content")}`)
            .stop()
            .slideToggle();
        });
});
$('.carousel').flickity({
  cellSelector: '.carousel__slide',
  wrapAround : true,
  autoPlay: true,
  // fade: true,
  imagesLoaded: true
});


$('.top_bar_slider').slick({
  dots: false,
  arrows:false,
  infinite: true,
  fade: true,
  speed: 300,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  cssEase: 'ease-in-out',
  adaptiveHeight: true
});

$('.colorwheel-slider').flickity({
  cellSelector: '.flickty_item',
  wrapAround : false,
  autoPlay: false,
  fade: false,
  freeScroll: true,
  contain: true,
  pageDots: false,
  cellAlign: 'left',
  groupCells: true,
});

$('#newarrival_slider').flickity({
  cellSelector: '.newarrival_slide',
  wrapAround : false,
  autoPlay: false,
  fade: false,
  // freeScroll: true,
  contain: true,
  pageDots: false,
  cellAlign: 'left',
  groupCells: true,
  imagesLoaded: true,
  selectedAttraction: 0.05,
  freeScroll: true,
  freeScrollFriction: 0.03
});

$('.custom-carousel-slider').flickity({
  cellSelector: '.newarrival_slide',
  wrapAround : false,
  autoPlay: false,
  fade: false,
  // freeScroll: true,
  contain: true,
  pageDots: false,
  cellAlign: 'left',
  groupCells: true,
  imagesLoaded: true,
  selectedAttraction: 0.05,
  freeScroll: true,
  freeScrollFriction: 0.03
});
$('.home_review_slider').flickity({
  cellSelector: '.home_review_slide',
  wrapAround : false,
  autoPlay: 10000,
  fade: false,
  imagesLoaded: true,
  selectedAttraction: 0.01,
friction: 0.15
})


  
// $('.holidays_main_slider').flickity({
//   cellSelector: '.newarrival_slidenew',
//   wrapAround : false,
//   autoPlay: false,
//   fade: false,
//   // freeScroll: true,
//   contain: true,
//   pageDots: false,
//   cellAlign: 'left',
//   groupCells: true,
//   imagesLoaded: true,
//   selectedAttraction: 0.05,
//   freeScroll: true,
//   freeScrollFriction: 0.03
// });
  
$('.color-wheel-box.tab-menu ul li.tab-a a').click(function(){
var $carousel = $('.colorwheel-slider').flickity();
$carousel.flickity('destroy');
    $(".colorwheel-slider").flickity({
        cellSelector: '.flickty_item',
        wrapAround : false,
        autoPlay: false,
        fade: false,
        freeScroll: true,
        contain: true,
        pageDots: false,
        cellAlign: 'left',
        groupCells: true,
    });    
});
 
  $('.tab-p').click(function(){
  $(".tab.prtab").removeClass('tab-active');
  $(".tab.prtab[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
  //$(".tab.prtab").fadeIn();
  $(".tab-p").removeClass('active-p');
  $(this).parent().find(".tab-p").addClass('active-p');
  });


  $('.tab-a').click(function(){  
    var getdataid =$(this).attr("data-id");
    //console.log(getdataid);
    $(".tab.colotab").removeClass('tab-active');
    $(".tab.colotab[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
    $(".tab-a").removeClass('active-a');
    $("ul").find("[data-id='" + getdataid + "']").addClass('active-a');
  });

  $(".js-hamburgernav").click(function(){
    $(".navmm").toggleClass("is-activenav");
    $("body").addClass("header_sticky");
  });

/////////////////// product +/-
  $('.num-in span').click(function () {
    var $input = $(this).parents('.num-block').find('input.in-num');
    if($(this).hasClass('minus')) {
      var count = parseFloat($input.val()) - 1;
      count = count < 1 ? 1 : count;
      if (count < 2) {
        $(this).addClass('dis');
      }
      else {
        $(this).removeClass('dis');
      }
      $input.val(count);
    }
    else {
      var count = parseFloat($input.val()) + 1
      $input.val(count);
      if (count > 1) {
        $(this).parents('.num-block').find(('.minus')).removeClass('dis');
      }
    }
    $input.change();
    return false;
  });

// product +/-

$(window).scroll(function(){
  if ($(this).scrollTop() > 0) {
    $('.header_Nav').addClass('fixed-nav-container');
  } else {
    $('.header_Nav').removeClass('fixed-nav-container');
  }
}); 

  $(".btn-search, button.clear-btn").click(function(){
    $(".modal-search").slideDown().addClass('show');
    $("body").addClass('overflow_hide');
    setTimeout(function(){
      $('.search-form-navv .search_input').focus();
    },1000);
  });
  $(".close-search-modal").click(function(){
    $(".modal-search").slideUp().removeClass('show');
    $("body").removeClass('overflow_hide');
    $('.all_product_search').hide();
    $('.search-form-navv .search_input').val('');
  });

  $('.search-form-navv .clear-search').on('click',function(){
    $(this).parent('.search-form-navv').find('.search_input').val('');
    $('.all_product_search').hide();
  })

  var default_img = $('.accrodian-change-images img').attr('src');
  $(".set > a").on("click", function() {
    var data_video_src = $(this).attr('data-video-src');
    var data_img_src = $(this).attr('data-img-src');
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
      .siblings(".content")
      .slideUp(300);
      $(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
      //             $('.our_video-work').hide();
      $('.our_video-work').fadeOut(1000);
      //             $('.accrodian-change-images img').show();
      $('.accrodian-change-images img').attr("src", default_img);
      $('.accrodian-change-images img').fadeIn(1000);
    } else {
      $(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
      $(this)
      .find("i")
      .removeClass("fa-plus")
      .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(300);
      $(this)
      .siblings(".content")
      .slideDown(300);
      if(data_video_src){
        //               $('.our_video-work').show('slow');
        $('.our_video-work').fadeIn(1000);
        //               $('.accrodian-change-images img').hide();
        $('.accrodian-change-images img').fadeOut(1000);
        $('.accrodian-change-images video').attr("src", data_video_src);
      }else{
        //               $('.our_video-work').hide();
        $('.our_video-work').fadeOut(1000);
        //               $('.accrodian-change-images img').show();
        $('.accrodian-change-images img').attr("src", data_img_src);
        $('.accrodian-change-images img').fadeIn(1000);
      }
    }
  });

  $("#newbtnShowLess").click(function(){
      $('.product-desc-data').removeClass('showmore');
      $('.product-desc-data').fadeIn("slow").addClass('showless');
  });
  $("#newbtnShowMore").click(function(){
      $('.product-desc-data').removeClass('showless');
      $('.product-desc-data').fadeIn("slow").addClass('showmore');
  });

var getdeafultimg =$(".ourwork_feafult").attr("src");
$(function() {
  //console.log(getdeafultimg);
  $(".storytoggle-section").on('click', function(e) {
    var getclick = $(this).attr("data-toggle-content");
    var geticon = $(this).attr("data-toggle-icon");
    var getdata = $(this).attr("data-video");
    var getcontent_type=$(this).attr("content-ty");
    var getimagesrc=$("#"+ getdata).attr("src");
    if ($("#"+ getclick).attr('style')) {
      $("#"+ geticon).removeClass("fa-minus");
      $("#"+ geticon).addClass("fa-plus");
      $(".section-content").removeAttr("style");
      $(".ourwork_feafult").attr("src", getdeafultimg);
    }
    else {
      $(".accr").removeClass("fa-minus");
      $(".accr").addClass("fa-plus");
      $(".section-content").removeAttr("style");
      $("#"+ getclick).css("display", "block");
      $("#"+ geticon).removeClass("fa-plus");
      $("#"+ geticon).addClass("fa-minus");

      if(getcontent_type == 'video'){
        $(".ourwork_feafult").css("display",'none');
        $(".our_video-work").css("display",'block');
        $(".videosrc-our").attr("src", getimagesrc);
      }
      else{
        $(".our_video-work").css("display",'none');
        $(".ourwork_feafult").css("display",'block');
        $(".ourwork_feafult").attr("src", getimagesrc);
      }
    }

  });
});

setTimeout(function() {
  $(document).find('.tab').addClass('tab_hide');
}, 3200);

  if(!Modernizr.meter){
    alert('Sorry your brower does not support HTML5 progress bar');
  } else {
    var progressbar = $('#progressbar'),
        max = progressbar.attr('max'),
        time = (500/max)*5,	
        value = progressbar.val();

    var loading = function() {
      value += 1;
      addValue = progressbar.val(value);
      getop= value / 100 ;

      if (getop > 0.80 ){
        $(".color-wheel-section-homepagenav").removeAttr("style");
      }
      if (getop > 0.99 ){
        $(".html5-progress-bar").hide();
        $('#MainContent').removeClass('opacity_0');
      }

      $('.progress-value').html(value + '%');
      if (value == max) {
        clearInterval(animate);
      }
    };

    var animate = setInterval(function() {
      loading();
    }, time);
  };



$('.js-hamburgernav').on('click',function(){
  if($(".gradient").attr('data-click-state') == 1) {
    $(".gradient").attr('data-click-state', 0);
    $(".gradient").removeAttr('style');
  }
  else {
    $(".gradient").attr('data-click-state', 1);
    $(".gradient").css('overflow', 'hidden')
  }
});

$("body").on("click", ".btn-search__text", function(){
  // alert();
  if($(".search-mobile").attr('data-click-state') == 1) {
    $(".search-mobile").attr('data-click-state', 0);
    $(".search-mobile").removeClass('is-active');
  }
  else {
    $(".search-mobile").attr('data-click-state', 1);
    $(".search-mobile").addClass('is-active');
  }
});
$("body").on("click", ".search-mobile__back", function(){
  // alert();
  if($(".search-mobile").attr('data-click-state') == 1) {
    $(".search-mobile").attr('data-click-state', 0);
    $(".search-mobile").removeClass('is-active');

    setTimeout(function () {
      $(".gradient").attr('data-click-state', 1);
      $(".gradient").css('overflow', 'hidden')
    }, 2500);
  }

  else {
    $(".search-mobile").attr('data-click-state', 1);
    $(".search-mobile").addClass('is-active');
  }
});
// CODE FOR STARING THE NAVIGATION MENU 

$(".js-hamburger").click(function(){
  $(this).toggleClass("isactive");
});

  // $("#openmenunav").click(function(){
  //   toggleClass(".isactive");
  // });
});

// 
